<template>
  <div class="__card_note">
    <p class="__copy"><slot></slot></p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.__card_note {
  width: 100%;
  margin-top: 0 !important;
  background: #fef5e1;
  border-radius: 4px;
  padding: 10px 16px;
  .__copy {
    all: unset;
    b {
      font-weight: 600;
    }
  }
}
</style>